var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logo",attrs:{"to":_vm.to}},[_c('img',{attrs:{"src":_vm.logo,"alt":"Voicecasting"}})])}
var staticRenderFns = []

export { render, staticRenderFns }